import { jsx as _jsx } from "react/jsx-runtime";
import { antdNotification } from '../antd-app-provider';
import { useCallback, useEffect, useMemo, useState, } from 'react';
import LoadingScreen from '../../../components/loading/screen';
import chunkArray from '../../helpers/chunk-array';
import useDebounceFunction from '../../hooks/use-debounce-function';
import useLocale from '../locale-provider';
import { usePlatform } from '../platform-provider';
import { TranslationsProvider } from '../translations-provider';
import { processTranslationFiles } from '../translations-provider/translations-utils';
const AppTranslationsProvider = ({ children, translationsFiles, jsonFiles, }) => {
    const { selectedLocale } = useLocale();
    const [translationsData, setTranslationsData] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const { contentfulClient } = usePlatform();
    const fetchFiles = useDebounceFunction(useCallback(async () => {
        var _a;
        if (!translationsFiles.length || !contentfulClient)
            return;
        setIsLoading(true);
        try {
            const fileChunks = chunkArray(translationsFiles, 100);
            const allTranslations = {};
            for (const fileChunk of fileChunks) {
                const filesResponse = await contentfulClient.getEntries(Object.assign(Object.assign({}, { ['fields.key[in]']: fileChunk.join(',') }), { content_type: 'translationFile', locale: selectedLocale, limit: 100 }));
                const files = (_a = filesResponse.items) !== null && _a !== void 0 ? _a : [];
                const mapped = processTranslationFiles(files);
                Object.assign(allTranslations, mapped);
            }
            setTranslationsData(allTranslations);
        }
        catch (error) {
            antdNotification.error({
                message: 'Translations failed',
                description: error.message,
                placement: 'bottomLeft',
            });
            console.error(error.message);
        }
        finally {
            setIsLoading(false);
        }
    }, [contentfulClient, selectedLocale, translationsFiles]), 500, true);
    useEffect(() => {
        if (!contentfulClient)
            return;
        fetchFiles();
    }, [contentfulClient, fetchFiles]);
    const namespaces = useMemo(() => [...translationsFiles, ...Object.keys(jsonFiles)], [jsonFiles, translationsFiles]);
    if (isLoading)
        return _jsx(LoadingScreen, {});
    return (_jsx(TranslationsProvider, { selectedLocale: selectedLocale, jsonFiles: jsonFiles, translationsData: translationsData, namespaces: namespaces, children: children }));
};
export default AppTranslationsProvider;
